module.exports = __webpack_public_path__ + "assets/img/teacher (20).50e5195e.png";